import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Button from 'components/UI/Button';
import { TableFilter } from 'components/UI/Table';
import { useUnit } from 'effector-react';
import { $user } from 'models/user';
import { GroupsEnum } from 'types/users';

interface DateFilterProps {
	filter: TableFilter;
	setFilter: (filter: TableFilter) => void;
}

export const DateFilter: React.FC<DateFilterProps> = ({ filter, setFilter }) => {
	const user = useUnit($user);

	const [startDate, setStartDate] = React.useState(() => {
		return filter?.fromDate || new Date();
	});
	const [endDate, setEndDate] = React.useState(() => {
		return filter?.toDate || new Date();
	});

	const hasFullAccess = user?.groups?.includes(GroupsEnum.FULL_ACCESS);
	const retailDaysLimit = parseInt(process.env.REACT_APP_RETAIL_DAYS_LIMIT || '3', 10);
	
	// Ограничение дат только для пользователей без полного доступа
	const minAllowedDate = !hasFullAccess ? moment().subtract(retailDaysLimit, 'days').toDate() : null;

	const onChange = (dates: any) => {
		const [start, end] = dates;
		setStartDate(start);
		setEndDate(end);
		// Обновляем фильтр только когда выбраны обе даты
		// Если end не выбран (пользователь еще выбирает диапазон), используем текущую дату
		setFilter({ ...filter, fromDate: start, toDate: end ?? new Date() });
	};

	return (
		<DatePicker
			selected={startDate}
			onChange={onChange}
			startDate={startDate}
			endDate={endDate}
			customInput={<ExampleCustomInput />}
			selectsRange
			minDate={minAllowedDate}
			popperContainer={({ children }) => {
				const portal = document.getElementById('root') || document.body;
				return ReactDOM.createPortal(children, portal);
			}}
		/>
	);
};

// Вынесенный компонент для DatePicker
type ButtonProps = React.HTMLProps<HTMLButtonElement>;
const ExampleCustomInput = React.forwardRef<HTMLButtonElement, ButtonProps>(function DatePickerInput(
	{ value, onClick },
	ref,
) {
	return <Button onClick={onClick}>{value}</Button>;
});
